import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';
import { objectEntries } from './global.utils';

export function traverseControl<T extends AbstractControl>(
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  this: any,
  control: T,
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  callback: (control: AbstractControl) => any
): void {
  const result = callback.call(this, control);

  if (control instanceof FormGroup) {
    for (const childControl of Object.values(control.controls)) {
      traverseControl.call(this, childControl, callback);
    }
  }

  return result;
}

export function calculateNumberOfInvalidControls(
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  this: any,
  control: AbstractControl,
  callback: (control: AbstractControl, invalidCount: number) => void
): number {
  let result = 0;
  let formGroupLevelErrors = 0;

  if (control instanceof FormGroup && control.valid) {
    return result;
  }

  if (control instanceof FormGroup) {
    for (const childControl of Object.values(control.controls)) {
      result += calculateNumberOfInvalidControls.call(
        this,
        childControl,
        callback
      );
    }
  }

  // If there are validators on FormGroup itself, then include
  // them in final calculation
  if (control instanceof FormGroup) {
    formGroupLevelErrors = Object.keys(control.errors || {}).length;
  }

  result += formGroupLevelErrors;
  result += control instanceof FormControl && control.invalid ? 1 : 0;

  callback(control, result);

  return result;
}

function findControlNameInFormGroup(control: AbstractControl): string | null {
  const parent = control.parent;
  if (parent === null || parent instanceof FormArray) {
    return null;
  }

  // Should be always defined because we take FormGroup from target control itself.
  // This is why we have "!" assertion below
  const keyValuePair = objectEntries(parent.controls).find(
    // eslint-disable-next-line  @typescript-eslint/no-unused-vars
    ([key, c]) => {
      return c === control;
    }
  )!;

  return keyValuePair[0] as string;
}

export function buildPathForControl(control: AbstractControl): string[] {
  const result: string[] = [];

  helper(control);

  return result;

  function helper(node: AbstractControl): void {
    const controlName = findControlNameInFormGroup(node);

    result.unshift(controlName ?? 'root');

    if (node.parent === null) {
      return;
    }

    helper(node.parent!);
  }
}
